export const CONSTANTS = {
  errorToken: 142,
  notAuthorized: 143,
  code: 161,
  errorOccurred: 'Ocurrió un error, por favor vuelve a intentar.',
  existingMail: 'El correo electrónico ya se encuentra registrado.'
}
